import { render, staticRenderFns } from "./AuditWaitTimeForm.vue?vue&type=template&id=d4b6583e&"
import script from "./AuditWaitTimeForm.vue?vue&type=script&lang=js&"
export * from "./AuditWaitTimeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports